export default __webpack_public_path__ + "2024 Molecular Strong Coupling and Cavity Finesse.pdf";